/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Link } from 'react-router-dom';
import statuscomplete from '../../images/status-completed.png';
import plus from '../../images/Plus.png';
// import deleteicon from '../../images/Delete.png';
import eye from '../../images/eye.svg';
import subFunction from '../common/helpers';
import '../../css/workspaceCard.css';
import { prefixPath } from '../../utils/helpers';
import Urls from '../../utils/urls';
import BaseUrls from '../../utils/baseUrls';

interface customData {
  id: number | string,
  name: string,
  networks: number,
  nodes: number,
  members: number,
  createdAt: number|string,
  cardnumber: number,
  total: number,
  endpoints: number,
  deleteWorkspace:(x:string|number, y:number, z:number)=>void
  editWorkspace: (workspaceId:string|number, workspaceName:string)=>void
}

const CardWorkSpace = ({
  id,
  name,
  networks,
  nodes,
  members,
  endpoints,
  createdAt,
  cardnumber,
  total,
  deleteWorkspace,
  editWorkspace,

}: customData) => {
  // delete workspace method

  const splitName = name.trim().split(/[\s,-]+/);
  let first = splitName[0];
  let last = splitName[1];
  if (!first && !last) {
    first = 'z';
    last = 'd';
  }
  let initials: string;
  if (!last) {
    initials = `${first.charAt(0).toUpperCase()}`;
  } else {
    initials = `${first.charAt(0).toUpperCase()}${last.charAt(0).toUpperCase()}`;
  }

  const toWorkspaceById: string = prefixPath(`/workspace/${id}`);
  const theme = BaseUrls.getkey();
  const baseUrl = window.location.origin;
  const memberImg = baseUrl + prefixPath(`/img/${theme}/Members.png`);
  const nodeImg = baseUrl + prefixPath(`/img/${theme}/Nodes.png`);
  const networkImg = baseUrl + prefixPath(`/img/${theme}/Networks.png`);

  function setCookie(cookieName: string, value: string, t: number) {
    let expires = '';
    if (t) {
      const date = new Date();
      date.setTime(date.getTime() + (t * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${cookieName}=${value || ''}${expires}; path=/`;
  }

  function getCookie(cookieName: string) {
    const match = document.cookie.match(new RegExp(`(^| )${cookieName}=([^;]+)`));
    if (match) {
      return match[2];
    }

    return null;
  }
  const setRecent = () => {
    const date = new Date();
    const data = getCookie('recent');
    const list = [];
    const ids:string[] = [];
    if (data) {
      const tdata = JSON.parse(data);
      for (let j = tdata.length - 1; j >= 0; j -= 1) {
        ids.push(tdata[j].id);
        list.push(tdata[j]);
      }
    }
    while (list.length > 5) {
      list.pop();
    }
    if (!ids.includes(id.toString())) {
      list.push({
        id, name, link: toWorkspaceById, time: date,
      });
    }

    const rec = JSON.stringify(list);
    const setReload = localStorage.getItem('recentList');
    if (setReload && setReload === 'yes') {
      localStorage.setItem('recentList', 'no');
    } else if (setReload && setReload === 'no') {
      localStorage.setItem('recentList', 'yes');
    } else {
      localStorage.setItem('recentList', 'yes');
    }

    setCookie('recent', rec, 350);
  };

  return (
    <div className="col-lg-4 col-xl-3 col-md-6 col-sm-12 mt-5 ">
      <div className="card workSpaceCard">
        <div className="card-body">
          <div className="comp-FT">
            <div className="container-workname" id=""><div className="workname">{initials}</div></div>
          </div>
          <div className="d-flex justify-content-end">
            <div className="square" onMouseEnter={() => { subFunction('edit', cardnumber, total); }} onMouseLeave={() => { subFunction('edit', cardnumber, total); }}>
            <i className="far fa-edit" />
              <ul
                className="dropdown-menu collapse bg-card"
                aria-labelledby=""
                id={`edit${cardnumber}`}
              >
                <li className="dropdown-item" onClick={() => editWorkspace(id, name)}>
                  {' '}
                  <div className="mx-2">
                    Edit Name
                  </div>
                </li>
              </ul>
            </div>
            <div className="square2" style={{ borderRadius: '0px' }} onMouseEnter={() => { subFunction('hideAction', cardnumber, total); }} onMouseLeave={() => { subFunction('hideAction', cardnumber, total); }}>
            <i className="far fa-eye" />
              <ul
                className="dropdown-menu menucard collapse bg-card"
                aria-labelledby=""
                id={`hideAction${cardnumber}`}
              >
                <li className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => { setRecent(); }}>
                    <Link to={toWorkspaceById} state={name} style={{ textDecoration: 'none', color: 'black' }}>
                    <div className="mx-2">
                        View
                        workspace
                    </div>
                    </Link>
                </li>
              </ul>
            </div>
            <div className="square2" onMouseEnter={() => { subFunction('action', cardnumber, total); }} onMouseLeave={() => { subFunction('action', cardnumber, total); }}>
            <i className="fa fa-trash" />
              <ul
                className="dropdown-menu menucard collapse bg-card"
                aria-labelledby=""
                id={`action${cardnumber}`}
              >
                <li className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => { deleteWorkspace(id, networks, endpoints); }}>
                <div className="mx-2">
                  Delete
                  workspace
                </div>
                </li>
              </ul>
            </div>
          </div>
          <p className="mt-4">
            {' '}
            <Link to={toWorkspaceById} state={name} className="workspaceCardHeading activeTextColor text-capitalize" style={{ textDecoration: 'none' }} onClick={() => { setRecent(); }}>
              <strong>{name}</strong>
            </Link>
            {' '}
          </p>
          <div className="mt-2 a-tag">
              <div className="d-flex align-items-center">
                <div className="col-3 me-2">
                  <img src={networkImg} alt="" />
                </div>
                <div className="col-7 my-auto ms-1">Networks</div>
                <div className="col-3 my-auto">
                  <strong>{networks || 0}</strong>
                </div>
              </div>
          </div>
          <div className="mt-2 a-tag">
              <div className="d-flex align-items-center">
                <div className="col-3 me-2">
                  <img src={nodeImg} alt="" />
                </div>
                <div className="col-7 my-auto ms-1">Nodes</div>
                <div className="col-3 my-auto">
                  <strong>{nodes || 0}</strong>
                </div>
              </div>
          </div>
          <div className="mt-2 a-tag">
              <div className="d-flex align-items-center">
                <div className="col-3 me-2">
                  <img src={nodeImg} alt="" />
                </div>
                <div className="col-7 my-auto ms-1">RPC Endpoints</div>
                <div className="col-3 my-auto">
                  <strong>{endpoints || 0}</strong>
                </div>
              </div>
          </div>
          <div className="mt-2 a-tag ">
              <div className="d-flex align-items-center">
                <div className="col-3 me-2">
                  <img src={memberImg} alt="" />
                </div>
                <div className="col-7 my-auto ms-1">Members</div>
                <div className="col-3 my-auto">
                  <strong>{members}</strong>
                </div>
              </div>
          </div>
        </div>
        <div className="card-footer a-tag">
            <div className="d-flex">
              <div className="col-11">
                <p className="create m-auto mt-1">
                  Created on
                  {' '}
                  {(new Date(createdAt)).toDateString()}
                </p>
              </div>
              <div className="col-1">
                <img
                  data-bs-toggle="tooltip"
                  title="Process Completed"
                  src={statuscomplete}
                  alt=""
                />
              </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default CardWorkSpace;
